var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "收款详情",
        visible: _vm.dialogVisible,
        width: "60%",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "detail-info" }, [
        _c("p", [_vm._v("商家类型：" + _vm._s(_vm.detail.merchantType))]),
        _vm._v(" "),
        _c("p", [_vm._v("商家名称：" + _vm._s(_vm.detail.merchantName))]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "对账周期：" +
              _vm._s(_vm.detail.periodStart) +
              " 至 " +
              _vm._s(_vm.detail.periodEnd)
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-grid" }, [
          _c("div", { staticClass: "info-row" }, [
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("订单金额：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value text-danger" }, [
                _vm._v("¥" + _vm._s(_vm.detail.orderAmount)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("订单数量：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.detail.orderCount)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-row" }, [
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [
                _vm._v("福豆总抵扣："),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value text-danger" }, [
                _vm._v("¥" + _vm._s(_vm.detail.beanDeduction)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [
                _vm._v("第三方支付抵扣："),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value text-danger" }, [
                _vm._v("¥" + _vm._s(_vm.detail.thirdPartyDeduction)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-row" }, [
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [
                _vm._v("优惠券优惠："),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value text-danger" }, [
                _vm._v("¥" + _vm._s(_vm.detail.couponDiscount)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("积分抵扣：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value text-danger" }, [
                _vm._v("¥" + _vm._s(_vm.detail.pointsDeduction)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-row" }, [
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("损失金额：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value text-danger" }, [
                _vm._v("¥" + _vm._s(_vm.detail.lossAmount)),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-deduction-section" },
        [
          _c("p", { staticClass: "section-label" }, [_vm._v("福卡抵扣明细：")]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticClass: "table",
              attrs: {
                data: _vm.cardDeductionList,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "cardName",
                  label: "福卡名",
                  "min-width": "200",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "actualDeduction",
                  label: "实际总抵扣",
                  "min-width": "200",
                  align: "center",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }